module.exports = __webpack_public_path__ + "static/media/Collection-In-villa-experiences-Mobile.a76e4adb.jpg";